export default {
  name: "BeneficiaryDahsboard",

  data() {
    return {
      entity_name: sessionStorage.getItem('entity_name'), 
    };
  },
};